import { render, staticRenderFns } from "./CardIconImage.vue?vue&type=template&id=6584d1bd&scoped=true&"
import script from "./CardIconImage.vue?vue&type=script&lang=ts&"
export * from "./CardIconImage.vue?vue&type=script&lang=ts&"
import style0 from "./CardIconImage.vue?vue&type=style&index=0&id=6584d1bd&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6584d1bd",
  null
  
)

export default component.exports